
import { SaleDetails } from "@/types/sales";
import { calculateTotal as calculateTotalFromMetrics } from "./metrics";

export const groupByLeadSource = (policies: SaleDetails[] = []) => {
  return policies.reduce((acc, policy) => {
    const sourceType = policy.lead_source || 'Uncategorized';
    if (!acc[sourceType]) {
      acc[sourceType] = [];
    }
    acc[sourceType].push(policy);
    return acc;
  }, {} as Record<string, SaleDetails[]>);
};

export const groupByCarrier = (policies: SaleDetails[] = []) => {
  return policies.reduce((acc, policy) => {
    const carrier = policy.insurance_carrier || 'Unknown';
    if (!acc[carrier]) {
      acc[carrier] = [];
    }
    acc[carrier].push(policy);
    return acc;
  }, {} as Record<string, SaleDetails[]>);
};

export const groupByPolicyLine = (policies: SaleDetails[] = []) => {
  return policies.reduce((acc, policy) => {
    const line = policy.policy_line || 'Unknown';
    if (!acc[line]) {
      acc[line] = [];
    }
    acc[line].push(policy);
    return acc;
  }, {} as Record<string, SaleDetails[]>);
};

// Use the unified implementation from metrics module
// Calculate total sales (base premium + endorsement premium) for an array of policies
export const calculateTotal = (policies: SaleDetails[] = []): number => {
  return policies.reduce((sum, policy) => {
    const basePremium = Number(policy.premium_amount) || 0;
    const endorsementPremium = Number(policy.endorsement_premium) || 0;
    return sum + basePremium + endorsementPremium;
  }, 0);
};
